var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header_tabs"},[_c('router-link',{staticClass:"header_tabs-item",class:_vm.$route.name === _vm.getPreviewLink && 'header_tabs-item--active',attrs:{"to":{
            name: _vm.getPreviewLink
        }}},[_vm._v(" Preview ")]),_c('router-link',{staticClass:"header_tabs-item",class:_vm.$route.name === ("edit-post-" + _vm.type + "-history") && 'header_tabs-item--active',attrs:{"to":{
            name: ("edit-post-" + _vm.type + "-history")
        }}},[_vm._v(" History ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }